import moment from "moment";

//import './main.js';
(function () {
    "use strict";
    var swalTitle = "Are you sure?";
    var swalConfirmDeleteMsg = "You won't be able to revert this!";
    var swalConfirmBtn = "Yes, delete";
    var swalCancelBtn = "Cancel";
    var swalCancelBtnColor = "#ff3547";
    var swalConfirmBtnColor = "#00c851";
    var swalBtnBlue = "#0d6efd";
    var swalBtnRed = "#d33";
    var swalBtnGreen = "#198754";

    var userDataTable,
        userAddressDataTable,
        userOrderHistoryDataTable,
        smtpDataTable,
        staffDataTable,
        serviceDataTable,
        providerDataTable,
        handymanScheduleDataTable,
        activityLogDataTable,
        appointmentsDataTable,
        quotationDataTable,
        projectDataTable,
        propertyDataTable;

    var handymanScript = {
        generalElements: function () {
            /**
             * Setup CSRF token in ajax request
             */
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            /**
             * This is for delete buttons that are loaded via AJAX in datatables, they will not work right
             * without this block of code
             */
            $(document).ajaxComplete(function () {
                handymanScript.addDeleteForms();
                $('.hmselect2').select2({});

                // Reinitialize tooltips for dynamically loaded content
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                tooltipTriggerList.map(function (tooltipTriggerEl) {
                    // Dispose existing tooltip if it exists to avoid duplicates
                    var existingTooltip = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                    if (existingTooltip) {
                        existingTooltip.dispose();
                    }
                    return new bootstrap.Tooltip(tooltipTriggerEl);
                });
            });


            /**
             * Generic confirm form delete using Sweet Alert
             */
            $('body').on('submit', 'form[name=delete_item]', function (e) {
                e.preventDefault();
                var form = this;
                var link = $('a[data-method="delete"]');
                var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : 'Type "DELETE" to confirm deletion. This action cannot be undone!';

                Swal.fire({
                    title: title,
                    text: text,
                    input: 'text',
                    inputPlaceholder: 'Type DELETE here',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: cancel,
                    confirmButtonText: confirm,
                    reverseButtons: true,
                    preConfirm: (inputValue) => {
                        if (inputValue !== 'DELETE') {
                            Swal.showValidationMessage('You must type "DELETE" to proceed.');
                            return false;
                        }
                        return true;
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        form.submit();
                    }
                });
            });

            // Initialize select2
            $('.hmselect2').select2({

            });

            // Set default config for jquery validate
            $.validator.setDefaults({
                debug: false,
                errorClass: 'is-invalid',
                validClass: 'is-valid',
                errorElement: 'div',
                errorPlacement: function (error, element) {
                    error.addClass('invalid-feedback');
                    if (element.prop("type") === "checkbox") {
                        error.insertAfter(element.next("label"));
                    } else if (element.prop("type") === "select-one") {
                        error.insertAfter(element.next('span'));
                    } else {
                        error.insertAfter(element);
                    }
                    //error.insertAfter( element );
                }
            });

            // Validate all the form which have .form-validate class
            $('.form-validate').each(function () {
                $(this).validate({
                    submitHandler: function (form) {
                        handymanScript.disableSubmitButton();
                        form.submit();
                    }
                });
            });

            // Display profile pic preview
            $('#profile_pic').change(function (event) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('.profile_pic_preview').attr('src', e.target.result).show();
                };
                reader.readAsDataURL(event.target.files[0]);
            });

            // Toggle password
            $('.toggle-password').on('click', function () {
                const icon = $(this).find('i');
                const input = $(this).siblings('input');
                const type = input.attr('type') === 'password' ? 'text' : 'password';
                input.attr('type', type);
                icon.toggleClass('bi-eye bi-eye-slash');
            });
        },
        /**
         * Allows you to add data-method="METHOD to links to automatically inject a form
         * with the method on click
         *
         * Example: <a href="{{route('customers.destroy', $customer->id)}}"
         * data-method="delete" name="delete_item">Delete</a>
         *
         * Injects a form with that's fired on click of the link with a DELETE request.
         * Good because you don't have to dirty your HTML with delete forms everywhere.
         */
        addDeleteForms: function () {
            $('[data-method]').append(function () {
                if (!$(this).find('form').length > 0)
                    return "\n" +
                        "<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                        "   <input type='hidden' name='_method' value='" + $(this).attr('data-method').toUpperCase() + "'>\n" +
                        "   <input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                        "</form>\n";
                else
                    return "";
            })
                .removeAttr('href')
                .attr('style', 'cursor:pointer;')
                .attr('onclick', '$(this).find("form").submit();');
        },
        // Bulk check / uncheck
        bulkCheckUncheck: function () {
            // Bulk delete
            // When check/uncheck the check all button
            $('#checked-all').on('change', function () {
                if ($(this).is(':checked')) {
                    $('.single-check').prop('checked', true).trigger('change');
                }
                else {
                    $('.single-check').prop('checked', false).trigger('change');
                }
            });

            // when check / uncheck single checkbox
            $('body').on('change', '.single-check', function () {
                let totalItems = $('.single-check').length;
                let totalCheckedItems = $('.single-check:checked').length;
                if (totalCheckedItems === 0) {
                    $('#checked-all').prop('checked', false);
                    $('#checked-all').prop('indeterminate', false);
                }
                else if (totalCheckedItems < totalItems) {
                    $('#checked-all').prop('indeterminate', true);
                }
                else if (totalCheckedItems === totalItems) {
                    $('#checked-all').prop('checked', true);
                    $('#checked-all').prop('indeterminate', false);
                }

                // Show / hide bulk delete button
                if (totalCheckedItems > 0) {
                    $('#bulk-delete-row').removeClass('d-none');
                }
                else {
                    $('#bulk-delete-row').addClass('d-none');
                }
            });
        },
        displayToastNotification: function (type, heading, message) {
            $.toast({
                heading: heading,
                text: message,
                position: 'top-right',
                showHideTransition: 'slide',
                icon: type
            })
        },
        // Disabled the submit button
        disableSubmitButton: function () {
            $('button[type="submit"]').attr('disabled', true).addClass('disabled');
        },
        // Initialize users dataTable
        userDataTable: function () {
            if ($('#users-table').length) {
                userDataTable = $('#users-table').DataTable({
                    pageLength: 10,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    dom: "<'row'<'col-sm-12 col-md-6 d-flex justify-content-start'l i><'col-sm-12 col-md-6'f>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>",
                    ajax: {
                        url: user_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        //{data: 'bulk_action', name: 'bulk_action', searchable: false, sortable: false},
                        { data: 'name', name: 'name' },
                        { data: 'email', name: 'email' },
                        { data: 'phone_number', name: 'phone_number' },
                        { data: 'account_type', name: 'account_type' },
                        { data: 'status', name: 'status', class: 'text-center' },
                        /* {data: 'created_at', name: 'created_at', class: 'text-center'}, */
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...',
                        lengthMenu: '_MENU_'
                    },
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    rowCallback: function (row, data, index) {
                        $(row).find('td:not(:last-child)').on('click', function () {
                            window.location.href = "/admin/users/" + data.id + "/edit";
                        });
                    }
                });

                // On init complete add a class
                userDataTable.on('init', function () {
                    $('#users-table_info').addClass('ps-2 pt-1');
                });

                // Bulk delete users
                $('#bulk-delete-btn').on('click', function () {
                    var ids = [];
                    $('input[type="checkbox"][name="ids[]"]:checked').each(function () {
                        ids.push($(this).val());
                    });
                    Swal.fire({
                        title: 'Are you sure?',
                        text: 'You won\'t be able to revert this!',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancel',
                        confirmButtonText: 'Yes, delete',
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            var buttonHtml = $(this).html();

                            // Enable loading on delete button
                            $(this).attr('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status"></span> Deleting...');
                            axios.post(user_bulk_delete_route, { ids: ids })
                                .then(function (response) {
                                    $('#bulk-delete-btn').attr('disabled', false).html(buttonHtml);
                                    $('#bulk-delete-row').addClass('d-none');
                                    $('#checked-all').prop('checked', false);
                                    $('#checked-all').prop('indeterminate', false);
                                    userDataTable.ajax.reload();
                                    if (response.data.status == 'success') {
                                        handymanScript.displayToastNotification('success', 'Success', 'Selected users deleted.');
                                    }
                                    else {
                                        handymanScript.displayToastNotification('error', 'Error', 'Unable to delete, please try again.');
                                    }
                                })
                                .catch(function (error) {

                                })
                        }
                    })
                });

                // Delete user
                $('body').on('click', '.delete-user', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    userDataTable.ajax.reload();
                                })
                        }
                    })
                })

                // Filter data
                // $('#filter-result').on('click', function () {
                //     $('#filter-result').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Searching...').addClass('disabled');
                //     userDataTable.ajax.reload();
                // });

                // // Reset filter
                // $('#reset-filters').on('click', function () {
                //     $('select[name="referred_by"]').val('').trigger('change');
                //     $('select[name="game_played"]').val('').trigger('change');
                //     $('select[name="deposit"]').val('').trigger('change');
                //     $('select[name="withdraw"]').val('').trigger('change');
                //     $('select[name="balance"]').val('').trigger('change');
                //     $('select[name="bonus"]').val('').trigger('change');
                //     $('select[name="spend"]').val('').trigger('change');
                //     $('select[name="lose"]').val('').trigger('change');
                //     $('select[name="win"]').val('').trigger('change');

                //     userDataTable.ajax.reload();
                // })
            }
        },
        handleUserCreate() {
            // Handle account type change
            $('[name="account_type"]').on('change', function () {
                let accountType = $(this).val();

                if (accountType === 'business' || accountType === 'individual') {
                    // Show the Save & Next button if account_type is business or individual
                    $('#saveAndNextButton').show();
                } else {
                    // Hide the Save & Next button if account_type is neither business nor individual
                    $('#saveAndNextButton').hide();
                }

                if (accountType === 'business') {
                    $('.business-info').removeClass('d-none');
                    $('.individual-info').addClass('d-none');
                } else if (accountType === 'individual') {
                    $('.business-info').addClass('d-none');
                    $('.individual-info').removeClass('d-none');
                } else {
                    $('.business-info').addClass('d-none');
                    $('.individual-info').addClass('d-none');
                }
            });

            // Add more contact person
            $('.add-more-contact-person').on('click', function () {

                $('.contact-person-container').removeClass('d-none');

                // Enabled the second contact person
                $('input[type="checkbox"][name="has_second_contact_person"]').prop('checked', true);
                // Hide the add more button
                $(this).parent('div').addClass('d-none');
            });

            // Remove contact person
            $('body').on('click', '.remove-contact-person', function () {
                $(this).parents('.contact-person-container').addClass('d-none');
                $('.add-more-contact-person').parent('div').removeClass('d-none');

                // Disable the second contact person
                $('input[type="checkbox"][name="has_second_contact_person"]').prop('checked', false);
            });

            // Validate and submit create user form
            if ($('#createUserForm').length > 0) {
                $('#createUserForm').validate({ // initialize the plugin
                    rules: {},
                    messages: {},
                    submitHandler: function (form) {
                        $(form)
                            .find('button[type="submit"]')
                            .attr('disabled', true)
                            .addClass('disabled')
                            .html('Processing...');
                        form.submit();
                    }
                });
            }
        },

        // Create user address
        handleCreateUserAdress() {
            // Add more contact person
            $('.add-more-address-contact-person').on('click', function () {

                $('.contact-person-container').removeClass('d-none');

                // Enabled the second contact person
                $('input[type="checkbox"][name="has_address_multiple_contact_person"]').prop('checked', true);
                // Hide the add more button
                $(this).parent('div').addClass('d-none');
            });

            // Remove contact person
            $('body').on('click', '.remove-address-contact-person', function () {
                $(this).parents('.contact-person-container').addClass('d-none');
                //$('.contact-person-container').find('.cp-head').text('Contact Person');
                $('.add-more-address-contact-person').parent('div').removeClass('d-none');

                // Disable the second contact person
                $('input[type="checkbox"][name="has_address_multiple_contact_person"]').prop('checked', false);
            });

            // Toggle address form
            $('#add-property').on('click', function () {
                $('#address-form-container').toggleClass('d-none');
            });

            // Prefill the contact persion information same as business contact person
            if (typeof business_cp !== 'undefined') {
                let businessCps = JSON.parse(business_cp);
                // Check if address_contact_person is defined in case of edit
                let addressCps = typeof address_contact_person !== 'undefined' ? JSON.parse(address_contact_person) : [];
                if (businessCps.length > 0) {
                    $('#same_as_business_0').on('change', function () {
                        let contactPersion = typeof businessCps[0] === 'object' ? businessCps[0] : {};
                        let prefix = '#cp_0_';
                        if ($(this).is(':checked')) {
                            // For person type business
                            $(prefix + 'person_type').val('business').trigger('change');
                            // Iterate over the business contact person and fill the form
                            // with the business contact person
                            $.each(contactPersion, function (key, value) {
                                $(prefix + key).val(value);
                                if (key == 'salutation') {
                                    $(prefix + key).trigger('change');
                                }
                            });
                        }
                        else {
                            let addressCp = typeof addressCps[0] === 'object' ? addressCps[0] : {};
                            // For person type business
                            // Check if addressCps is not empty
                            if (Object.keys(addressCp).length > 0) {
                                // Iterate over the address contact person and fill the form
                                // with the address contact person
                                $.each(addressCp, function (key, value) {
                                    $(prefix + key).val(value);
                                    if (key == 'salutation') {
                                        $(prefix + key).trigger('change');
                                    }
                                });
                            }
                            else {
                                $(prefix + 'person_type').val('').trigger('change');
                                $.each(contactPersion, function (key, value) {
                                    $(prefix + key).val('');
                                    if (key == 'salutation') {
                                        $(prefix + key).val('').trigger('change');
                                    }
                                });
                            }
                        }
                    });

                    // Select the business contact person for second
                    $('#same_as_business_1').on('change', function () {
                        let contactPersion = typeof businessCps[1] === 'object' ? businessCps[1] : {};
                        // Check if address_contact_person is defined in case of edit
                        let addressCps = typeof address_contact_person !== 'undefined' ? JSON.parse(address_contact_person) : [];
                        let prefix = '#cp_1_';
                        if ($(this).is(':checked')) {
                            // For person type business
                            $(prefix + 'person_type').val('business').trigger('change');
                            // Iterate over the business contact person and fill the form
                            // with the business contact person
                            $.each(contactPersion, function (key, value) {
                                $(prefix + key).val(value);
                                if (key == 'salutation') {
                                    $(prefix + key).trigger('change');
                                }
                            });
                        }
                        else {
                            let addressCp = typeof addressCps[1] === 'object' ? addressCps[1] : {};
                            // For person type business
                            // Check if addressCps is not empty
                            if (Object.keys(addressCp).length > 0) {
                                // Iterate over the address contact person and fill the form
                                // with the address contact person
                                $.each(addressCp, function (key, value) {
                                    $(prefix + key).val(value);
                                    if (key == 'salutation') {
                                        $(prefix + key).trigger('change');
                                    }
                                });
                            }
                            else {
                                $(prefix + 'person_type').val('').trigger('change');
                                $.each(contactPersion, function (key, value) {
                                    $(prefix + key).val('');
                                    if (key == 'salutation') {
                                        $(prefix + key).val('').trigger('change');
                                    }
                                });
                            }
                        }
                    });
                }
            }

            // Check if user address table exists
            if ($('#user-address-table').length > 0) {
                userAddressDataTable = $('#user-address-table').DataTable({
                    pageLength: 10,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: user_address_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'full_address', name: 'full_address' },
                        //{data: 'phone_number', name: 'phone_number'},
                        { data: 'city', name: 'city' },
                        //{data: 'county', name: 'county'},
                        { data: 'postal_code', name: 'postal_code' },
                        //{data: 'created_at', name: 'created_at'},
                        { data: 'status', name: 'status', class: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    rowCallback: function (row, data, index) {
                        $(row).find('td:not(:last-child)').on('click', function () {
                            window.location.href = "/admin/users/edit-address/" + data.user_id + "/" + data.id;
                        });
                    }
                });

                // Delete the user address
                $('body').on('click', '.delete-user-address', function (e) {
                    e.preventDefault();
                    let url = $(this).attr('href');

                    var link = $('a[data-method="delete"]');
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(url)
                                .then(function (response) {
                                    if (response.data.status === 'success') {
                                        handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                        userAddressDataTable.ajax.reload();
                                    }
                                    else {
                                        handymanScript.displayToastNotification('error', 'Error', response.data.message);
                                    }
                                });
                        }
                    });

                });
            }
        },

        handleCreateUserRecurringServices() {
            if ($('#recurring-service-table').length) {
                // First, fetch services to know how many columns we need
                $.ajax({
                    url: user_recurring_service_list_route,
                    type: 'post',
                    data: {
                        start: 0,
                        length: 1,
                        draw: 1
                    },
                    success: function (response) {
                        // Build columns based on services
                        const columns = [
                            { data: 'full_address', name: 'full_address', orderable: false }
                        ];

                        // Update headers and build columns
                        if (response.services && response.services.length > 0) {
                            const headerRow = $('#recurring-service-table thead tr');
                            headerRow.find('th:not(:first)').remove();

                            response.services.forEach((service, index) => {
                                headerRow.append('<th class="text-center">' + service.name + '</th>');
                                columns.push({
                                    data: 'service_' + (index + 1) + '_due_date',
                                    name: 'service_' + (index + 1) + '_due_date',
                                    orderable: false,
                                    searchable: false,
                                    className: 'text-center'
                                });
                            });
                        }

                        // Now initialize DataTable with correct columns
                        $('#recurring-service-table').DataTable({
                            pageLength: 25,
                            stateSave: false,
                            processing: true,
                            serverSide: true,
                            responsive: true,
                            lengthChange: false,
                            searching: true,
                            ajax: {
                                url: user_recurring_service_list_route,
                                type: 'post'
                            },
                            columns: columns,
                            language: {
                                emptyTable: 'No properties found.',
                                search: '',
                                searchPlaceholder: 'Search properties...',
                                processing: 'Loading...'
                            },
                            order: []
                        });
                    },
                    error: function () {
                        console.error('Failed to load services');
                    }
                });
            }
        },
        handleUserOrderHistory() {
            // Check if user address table exists
            if ($('#customer-order-history-table').length > 0) {
                userOrderHistoryDataTable = $('#customer-order-history-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: get_customer_order_history,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'order_number', name: 'order_number' },
                        { data: 'address', name: 'address' },
                        { data: 'status', name: 'status' },
                        { data: 'customer_name', name: 'customer_name', searchable: false, sortable: false, },
                        { data: 'assign_to', name: 'assign_to', searchable: false, sortable: false, },
                        { data: 'final_amount', name: 'final_amount', class: 'text-end pe-4' },
                        { data: 'updated_at', name: 'updated_at', className: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[4, "desc"]],
                    searchDelay: 500
                });

                // Delete the user address
                $('body').on('click', '.delete-user-address', function (e) {
                    e.preventDefault();
                    let url = $(this).attr('href');

                    var link = $('a[data-method="delete"]');
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(url)
                                .then(function (response) {
                                    if (response.data.status === 'success') {
                                        handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                        userAddressDataTable.ajax.reload();
                                    }
                                    else {
                                        handymanScript.displayToastNotification('error', 'Error', response.data.message);
                                    }
                                });
                        }
                    });

                });
            }
        },

        // Handle Address Order History dataTable
        handleAddressOrderHistory() {
            if ($('#address-order-history-table').length > 0) {
                $('#address-order-history-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: get_address_order_history,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'order_number', name: 'order_number' },
                        { data: 'address', name: 'address' },
                        { data: 'status', name: 'status' },
                        { data: 'customer_name', name: 'customer_name', searchable: false, sortable: false, },
                        { data: 'assign_to', name: 'assign_to', searchable: false, sortable: false, },
                        { data: 'final_amount', name: 'final_amount', class: 'text-end pe-4' },
                        { data: 'updated_at', name: 'updated_at', className: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[6, "desc"]],
                    searchDelay: 500
                });
            }
        },

        // Handle SMTP dataTable
        smtpDataTable: function () {
            if ($('#smtps-table').length) {
                smtpDataTable = $('#smtps-table').DataTable({
                    pageLength: 10,
                    stateSave: true,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: smtp_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        //{data: 'bulk_action', name: 'bulk_action', searchable: false, sortable: false},
                        { data: 'host', name: 'host' },
                        { data: 'username', name: 'username' },
                        { data: 'from_email', name: 'from_email' },
                        { data: 'from_name', name: 'from_name' },
                        { data: 'status', name: 'status' },
                        { data: 'created_at', name: 'created_at', class: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[5, "desc"]],
                    searchDelay: 500
                });

                // Bulk delete smtps
                $('#bulk-delete-btn').on('click', function () {
                    var ids = [];
                    $('input[type="checkbox"][name="ids[]"]:checked').each(function () {
                        ids.push($(this).val());
                    });
                    Swal.fire({
                        title: 'Are you sure?',
                        text: 'You won\'t be able to revert this!',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancel',
                        confirmButtonText: 'Yes, delete',
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            var buttonHtml = $(this).html();

                            // Enable loading on delete button
                            $(this).attr('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status"></span> Deleting...');
                            axios.post(user_bulk_delete_route, { ids: ids })
                                .then(function (response) {
                                    $('#bulk-delete-btn').attr('disabled', false).html(buttonHtml);
                                    $('#bulk-delete-row').addClass('d-none');
                                    $('#checked-all').prop('checked', false);
                                    $('#checked-all').prop('indeterminate', false);
                                    smtpDataTable.ajax.reload();
                                    if (response.data.status == 'success') {
                                        handymanScript.displayToastNotification('success', 'Success', 'Selected users deleted.');
                                    }
                                    else {
                                        handymanScript.displayToastNotification('error', 'Error', 'Unable to delete, please try again.');
                                    }
                                })
                                .catch(function (error) {

                                })
                        }
                    })
                });

                // Delete smtp
                $('body').on('click', '.delete-smtp', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.post(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    smtpDataTable.ajax.reload();
                                })
                        }
                    })
                });

                // Change SMTP status
                $('body').on('click', '.change-smtp-status', function (e) {
                    e.preventDefault();
                    let smtpId = $(this).attr('data-id');
                    let action = $(this).attr('data-link');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, change";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.post(action, { smtp_id: smtpId })
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    smtpDataTable.ajax.reload();
                                })
                        }
                    })
                });
            }
        },

        staffDataTable() {
            // Check if user address table exists
            if ($('#staff-table').length > 0) {
                staffDataTable = $('#staff-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: staff_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'email', name: 'email' },
                        { data: 'phone_number', name: 'phone_number' },
                        { data: 'role', name: 'role' },
                        { data: 'status', name: 'status', class: 'text-center pe-2' },
                        { data: 'created_at', name: 'created_at', class: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[0, "asc"]],
                    searchDelay: 500
                });

                // Delete staff
                $('body').on('click', '.delete-staff', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    staffDataTable.ajax.reload();
                                })
                        }
                    })
                });
            }

            // Create staff common actions
            // When change the role of staff
            $('body').on('change', '#staff-role', function () {
                let role = $(this).val();
                console.log($.isArray(role));
                // First uncheck all the permissions checkbox
                $('input[type=checkbox]').prop('checked', false);
                // Then check only the permissions of the selected role
                if ($.isArray(role)) {
                    for (let i = 0; i < role.length; i++) {
                        $('input[type=checkbox][data-role=' + role[i] + ']').prop('checked', true);
                    }
                }
                else {
                    $('input[type=checkbox][data-role=' + role + ']').prop('checked', true);
                }
            })
        },

        serviceDataTable() {
            // Check if user address table exists
            if ($('#service-table').length > 0) {
                serviceDataTable = $('#service-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: service_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'recurring_services', name: 'recurring_services', class: 'text-center' },
                        { data: 'price', name: 'price', class: 'text-end' },
                        { data: 'labour_cost', name: 'labour_cost', class: 'text-end' },
                        { data: 'description', name: 'description' },
                        { data: 'status', name: 'status', class: 'text-center' },
                        { data: 'created_at', name: 'created_at', class: 'text-end' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[6, "desc"]],
                    searchDelay: 500
                });

                // Delete staff
                $('body').on('click', '.delete-service', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    serviceDataTable.ajax.reload();
                                })
                        }
                    })
                });
            }

            // When change the recurring service
            $('body').on('change', 'select[name="recurring_services"]', function () {
                let recurring_services = $(this).val();
                if (recurring_services == 1) {
                    $('#service_interval').removeClass('d-none');
                }
                else {
                    $('#service_interval').addClass('d-none');
                }
            })
        },

        providerDataTable() {
            // Check if user address table exists
            if ($('#providers-table').length > 0) {
                providerDataTable = $('#providers-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: provider_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'email', name: 'email' },
                        { data: 'phone_number', name: 'phone_number' },
                        { data: 'status', name: 'status', class: 'text-center pe-2' },
                        { data: 'created_at', name: 'created_at', class: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[4, "desc"]],
                    searchDelay: 500
                });

                // Delete staff
                $('body').on('click', '.delete-providers', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action, {
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                            })
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    providerDataTable.ajax.reload();
                                })
                        }
                    })
                });
            }
        },
        // Handyman schedule data table
        scheduleDataTable() {
            if ($('#handyman-schedule-table').length > 0) {
                handymanScheduleDataTable = $('#handyman-schedule-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: schedule_list,
                        type: 'post',
                        data: function (d) {
                            d.status = $('#status-select').val();
                        }
                    },
                    columns: [
                        { data: 'full_name', name: 'full_name' },
                        { data: 'schedule_date', name: 'schedule_date', class: 'text-center' },
                        { data: 'start_time', name: 'start_time', class: 'text-center' },
                        { data: 'end_time', name: 'end_time', class: 'text-center' },
                        { data: 'status', name: 'status', class: 'text-center pe-2' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[1, "asc"]],
                    searchDelay: 500
                });

                // Delete staff
                $('body').on('click', '.delete-schedule', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    handymanScheduleDataTable.ajax.reload();
                                })
                        }
                    })
                });

                // On close modal #editScheduleModal reload table
                document.addEventListener('scheduleUpdated', function (event) {
                    let details = event.detail;
                    handymanScript.displayToastNotification(details.status, details.status, details.message);
                    handymanScheduleDataTable.ajax.reload();
                });

                $(window).on('vue-to-jquery', function (event) {
                    console.log("event received");
                    let details = event.originalEvent.detail;
                    //handymanScript.displayToastNotification(details.status, details.status, details.message);
                    handymanScheduleDataTable.ajax.reload();
                });

                // Move select box just before the filter
                $('#table-custom-filters').appendTo('#handyman-schedule-table_filter').removeClass('d-none');
                $('#status-select').on('change', function () {
                    handymanScheduleDataTable.ajax.reload();
                })
            }
        },
        // Validate change password form
        validateChangePasswordForm: function () {
            $(".change-password-form").validate({
                rules: {
                    current_password: {
                        required: true
                    },
                    new_password: {
                        required: true
                    },
                    new_password_confirmation: {
                        required: true,
                        equalTo: "#new_password"
                    }
                },
                messages: {
                    current_password: {
                        required: "Please enter your current password."
                    },
                    new_password: {
                        required: "Please enter a new password."
                    },
                    new_password_confirmation: {
                        required: "Please confirm your new password.",
                        equalTo: "Passwords do not match with new password."
                    }
                },
                submitHandler: function (form) {
                    form.submit();
                }
            });
        },
        activityLogDataTable() {
            if ($('#activity-log-table').length > 0) {
                activityLogDataTable = $('#activity-log-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: activity_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'description', name: 'description' },
                        { data: 'created_at', name: 'created_at', class: 'text-center' },
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[2, "desc"]],
                    searchDelay: 500
                });
            }
        },
        manageAppointments() {
            if ($('#appointments-table').length > 0) {
                appointmentsDataTable = $('#appointments-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: appointment_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'title', name: 'title' },
                        { data: 'name', name: 'name' },
                        { data: 'appointment_date', name: 'appointment_date', class: 'text-center' },
                        { data: 'appointment_time', name: 'appointment_time', class: 'text-center' },
                        { data: 'actions', name: 'actions', class: 'text-center', sortable: false, searchable: false },
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[2, "desc"]],
                    searchDelay: 500
                });

                $('body').on('click', '.delete-appointment', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    appointmentsDataTable.ajax.reload();
                                })
                        }
                    })
                });
            }
        },
        manageQuotations() {
            if ($('#quotations-table').length > 0) {
                quotationDataTable = $('#quotations-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: quotation_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'email', name: 'email' },
                        { data: 'sub_total_amount', name: 'sub_total_amount', class: 'text-center' },
                        { data: 'created_at', name: 'created_at', class: 'text-center' },
                        { data: 'actions', name: 'actions', class: 'text-center', sortable: false, searchable: false },
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[3, "desc"]],
                    searchDelay: 500
                });

                $('body').on('click', '.delete-quotation', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    quotationDataTable.ajax.reload();
                                })
                        }
                    })
                });
            }
        },
        handleWhatsAppMessage() {
            // Validate single send message form
            if ($('#sendSingleWpMessageForm').length > 0) {
                // When select user is changed then prefill the phone number field
                $("#sendSingleWpMessageForm select[name='user_name']").on('change', function () {
                    let phoneNumber = $(this).find(':selected').data('phone');
                    $("#sendSingleWpMessageForm input[name='receiver']").val(phoneNumber);
                });

                $("#sendSingleWpMessageForm").validate({
                    rules: {},
                    messages: {},
                    submitHandler: function (form) {
                        // Disable the submit button
                        $(form).find('button[type="submit"]').attr('disabled', true).addClass('disabled');

                        // Send the message to the user
                        axios.post(send_single_wp_message_route, {
                            authkey: send_single_wp_message_key,
                            receiver: $("#sendSingleWpMessageForm input[name='receiver']").val(),
                            message: $("#sendSingleWpMessageForm textarea[name='message']").val(),
                        })
                            .then(function (response) {
                                if (response.data.status === 'success') {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);

                                    // Reset the form
                                    $("#sendSingleWpMessageForm").trigger('reset');
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            })
                            .finally(function () {
                                // Enable the submit button
                                $(form).find('button[type="submit"]').attr('disabled', false).removeClass('disabled');
                            });
                        return false;
                    }
                });
            }
        },
        handleProjects() {
            if ($('#projects-table').length > 0) {
                projectDataTable = $('#projects-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: project_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'projects.name' },
                        { data: 'address', name: 'projects.address' },
                        { data: 'customer.name', name: 'users.name' },
                        { data: 'status', name: 'projects.status', class: 'text-center' },
                        { data: 'created_at', name: 'projects.created_at', class: 'text-center' },
                        { data: 'actions', name: 'actions', class: 'text-center', sortable: false, searchable: false },
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[4, "desc"]],
                    searchDelay: 500,
                    rowCallback: function (row, data, index) {
                        $(row).find('td:not(:last-child)').on('click', function () {
                            window.location.href = "/admin/projects/" + data.id;
                        });
                    }
                });

                $('body').on('click', '.delete-project-user', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "All related data will be deleted. You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification('success', 'Success', response.data.message);
                                    projectDataTable.ajax.reload();
                                })
                        }
                    })
                });
            }
        },
        handleStaticDataTable() {
            if ($('.static-data-table').length > 0) {
                $('.static-data-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    responsive: true,
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                });
            }
        },
        // Download staff data
        downloadStaffData() {
            if ($('#download-staff-btn').length > 0) {
                $('#download-staff-btn').on('click', function () {
                    let $btn = $(this);
                    let buttonHtml = $btn.html();
                    $btn.attr('disabled', true).html('<span class="spinner-border spinner-border-sm" role="status"></span> Downloading...');
                    axios.post('/api/admin/get-staff-data')
                        .then(function (response) {
                            if (response.data.status === 'success') {
                                let users = response.data.users;
                                let csvContent = "data:text/csv;charset=utf-8,";
                                let headers = "Name,Email,Phone Number,Role,Status,Created At\n";
                                csvContent += headers;
                                users.forEach(function (user) {
                                    // Prepare status
                                    let status = user.status === 1 ? 'Active' : 'Inactive';

                                    // If deleted at is not null then status is deleted
                                    if (user.deleted_at) {
                                        status = 'Deleted';
                                    }

                                    // Prepare roles
                                    let roles = user.roles.map(role => {
                                        let roleName = role.name;
                                        roleName = roleName.replace(/_/g, ' ');
                                        roleName = roleName.charAt(0).toUpperCase() + roleName.slice(1);
                                        return roleName;
                                    }).join(', ');

                                    if (roles === '') {
                                        roles = 'N/A';
                                    }

                                    // Prepare created at
                                    let createdAt = moment(user.created_at).format('DD/MM/YYYY');
                                    let row = [
                                        `"${user.full_name}"`,
                                        `"${user.email}"`,
                                        `"${user.phone_number}"`,
                                        `"${roles}"`,
                                        `"${status}"`,
                                        `"${createdAt}"`
                                    ];

                                    //let row = user.full_name + "," + user.email + "," + user.phone_number + "," + roles + "," + status + "," + createdAt + "\n";
                                    csvContent += row.join(',') + '\n';
                                });
                                let encodedUri = encodeURI(csvContent);
                                let link = document.createElement("a");
                                link.setAttribute("href", encodedUri);
                                link.setAttribute("download", "staff.csv");
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                        .finally(function () {
                            $btn.attr('disabled', false).html(buttonHtml);
                        });
                });
            }
        },
        propertyDataTable: function () {
            if ($('#properties-table').length) {
                propertyDataTable = $('#properties-table').DataTable({
                    pageLength: 10,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    dom: "<'row'<'col-sm-12 col-md-6 d-flex justify-content-start'l i><'col-sm-12 col-md-6'f>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>",
                    ajax: {
                        url: property_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        //{data: 'bulk_action', name: 'bulk_action', searchable: false, sortable: false},
                        { data: 'full_address', name: 'full_address' },
                        { data: 'postal_code', name: 'postal_code' },
                        { data: 'customer_name', name: 'customer_name' },
                        { data: 'status', name: 'status' },
                        { data: 'created_at', name: 'created_at' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...',
                        lengthMenu: '_MENU_'
                    },
                    order: [[4, "desc"]],
                    searchDelay: 500,
                    rowCallback: function (row, data, index) {
                        $(row).find('td:not(:last-child)').on('click', function () {
                            window.location.href = "/admin/address/" + data.id + "/edit";
                        });
                    }
                });

                // On init complete add a class
                propertyDataTable.on('init', function () {
                    $('#properties-table_info').addClass('ps-2 pt-1');
                });

                // Delete user
                $('body').on('click', '.delete-property', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : 'To proceed, you must type "DELETE" to confirm you understand the severity.';

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    if (response.data.status === 'success') {
                                        propertyDataTable.ajax.reload();
                                    }
                                    handymanScript.displayToastNotification(response.data.status, handymanScript.capitalize(response.data.status), response.data.message);
                                })
                                .catch(function (error) {
                                    handymanScript.displayToastNotification('error', 'Error', error.response.data.message);
                                })
                        }
                    })
                })
            }
        },
        capitalize(str) {
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
        manageQuotationTemplates() {
            if ($('#quotation-templates-table').length > 0) {
                let quotationTemplateDataTable = $('#quotation-templates-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: quotation_template_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'description', name: 'description' },
                        { data: 'quotations_count', name: 'quotations_count', class: 'text-center' },
                        { data: 'status', name: 'status', class: 'text-center' },
                        { data: 'created_at', name: 'created_at' },
                        { data: 'actions', name: 'actions', class: 'text-center', sortable: false, searchable: false },
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[4, "desc"]],
                    searchDelay: 500
                });

                $('body').on('click', '.delete-quotation-template', function (e) {
                    e.preventDefault();
                    let action = $(this).data('href');

                    var cancel = "Cancel";
                    var confirm = "Yes, delete";
                    var title = "Are you sure?";
                    var message = 'If you delete this template, it will be delete all quotations associated with this template. Are you sure?<br>Type "DELETE" here to proceed.';

                    Swal.fire({
                        //title: title,
                        html: message,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    if (response.data.status === 'success') {
                                        quotationTemplateDataTable.ajax.reload();
                                    }
                                    handymanScript.displayToastNotification(response.data.status, handymanScript.capitalize(response.data.status), response.data.message);
                                })
                        }
                    })
                });
            }
        },
        manageQuickQuotations() {
            if ($('#quick-quotations-table').length > 0) {
                let quickQuotationDataTable = $('#quick-quotations-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: quick_quotation_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'email', name: 'email' },
                        { data: 'template.name', name: 'template.name' },
                        { data: 'total_amount', name: 'total_amount', class: 'text-end pe-4' },
                        { data: 'created_at', name: 'created_at', class: 'text-end pe-4' },
                        { data: 'actions', name: 'actions', class: 'text-center', sortable: false, searchable: false },
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[3, "desc"]],
                    searchDelay: 500
                });

                $('body').on('click', '.delete-quick-quotation', function (e) {
                    e.preventDefault();
                    let action = $(this).data('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : 'Type "DELETE" to confirm deletion. This action cannot be undone!';

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    if (response.data.status === 'success') {
                                        quickQuotationDataTable.ajax.reload();
                                    }
                                    handymanScript.displayToastNotification(response.data.status, handymanScript.capitalize(response.data.status), response.data.message);
                                })
                        }
                    })
                });
            }
        },
        manageScheduledServices() {
            if ($('#scheduled-service-table').length > 0) {
                let scheduledServiceDataTable = $('#scheduled-service-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: scheduled_service_list_route,
                        type: 'post',
                        data: function (d) {

                        }
                    },
                    columns: [
                        { data: 'customer.name', name: 'customer.name' },
                        { data: 'property', name: 'address.full_address' },
                        { data: 'service.name', name: 'service.name' },
                        { data: 'next_due_date', name: 'next_due_date', class: 'text-end pe-4' },
                        { data: 'frequency', name: 'frequency' },
                        { data: 'status', name: 'status', class: 'text-center pe-3' },
                        { data: 'created_at', name: 'created_at', class: 'text-end pe-4' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[3, "desc"]],
                    searchDelay: 500
                });
            }
        },
        manageScheduledServicesDataTable() {
            if ($('#scheduled-service-data-table').length > 0) {
                let scheduledServiceDataTable = $('#scheduled-service-data-table').DataTable({
                    pageLength: 25,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    ajax: {
                        url: scheduled_services_data_table,
                        type: 'post',
                        data: function (d) {
                            d.date_range_months = $('#scheduled-service-filter-form select[name="date_range_months"]').val();
                            d.start_date = $('#scheduled-service-filter-form input[name="start_date"]').val();
                            d.end_date = $('#scheduled-service-filter-form input[name="end_date"]').val();
                            d.month = $('#scheduled-service-filter-form select[name="selected_month"]').val();
                            d.service_type = $('#scheduled-service-filter-form select[name="service_type"]').val();
                            d.customer_id = $('#scheduled-service-filter-form select[name="customer_id"]').val();
                            d.property_id = $('#scheduled-service-filter-form select[name="property_id"]').val();
                            d.service_id = $('#scheduled-service-filter-form select[name="service_id"]').val();
                            d.status = $('#scheduled-service-filter-form select[name="status"]').val();
                        }
                    },
                    columns: [
                        { data: 'service.name', name: 'service.name' },
                        { data: 'property', name: 'address.full_address' },
                        { data: 'tenant', name: 'tenant', orderable: false, searchable: false },
                        { data: 'customer', name: 'customer', orderable: false, searchable: false },
                        { data: 'next_due_date', name: 'next_due_date', class: 'text-end pe-4' },
                        { data: 'frequency', name: 'frequency' },
                        { data: 'status', name: 'status', class: 'text-center pe-3' },
                        { data: 'actions', name: 'actions', class: 'text-center', searchable: false, sortable: false }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...'
                    },
                    order: [[4, "asc"]],
                    ordering: false,
                    searchDelay: 500,
                    initComplete: function () {
                        // Move filter form inside DataTable wrapper after render (hidden by default)
                        var filterCard = $('#scheduled-service-filter').detach().hide();
                        $('#scheduled-service-data-table_wrapper .row:first').after(filterCard);

                        // Add Advanced Filter button next to search box
                        var advFilterBtn = '<button type="button" class="btn btn-sm btn-outline-theme ms-2" id="toggle-advanced-filter"><i class="bi bi-funnel"></i> Advanced Filter</button>';
                        $('#scheduled-service-data-table_filter').append(advFilterBtn);

                        // Toggle filter visibility on button click
                        $('#toggle-advanced-filter').on('click', function () {
                            $('#scheduled-service-filter').slideToggle();
                            $(this).toggleClass('btn-outline-theme btn-theme');
                        });

                        // Trigger click event on Advanced Filter button (after handler is attached)
                        $('#toggle-advanced-filter').trigger('click');
                    },
                });

                // Listen for recurring-services-saved event
                window.addEventListener('recurring-services-saved', function (event) {
                    if (scheduledServiceDataTable) {
                        scheduledServiceDataTable.ajax.reload();
                    }
                });

                // Delete scheduled service
                $('body').on('click', '.delete-scheduled-service', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');
                    console.log(action);

                    var cancel = "Cancel";
                    var confirm = "Yes, delete";
                    var title = "Confirm Deletion";
                    var html = 'This action cannot be undone. This will permanently delete the scheduled service and all associated data.<br/>Type "DELETE" to confirm:';

                    Swal.fire({
                        title: title,
                        html: html,
                        input: 'text',
                        //icon: 'warning',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    if (response.data.status === 'success') {
                                        scheduledServiceDataTable.ajax.reload();
                                    }
                                    handymanScript.displayToastNotification(response.data.status, handymanScript.capitalize(response.data.status), response.data.message);
                                })
                        }
                    })
                });

                // If route scheduled_service_filters is defined  then get the filter data
                if (scheduled_service_filters) {
                    axios.post(scheduled_service_filters)
                        .then(function (response) {
                            if (response.data.status === 'success') {
                                // Populate customers dropdown
                                var customerSelect = $('select[name="customer_id"]');
                                customerSelect.find('option:not(:first)').remove();
                                response.data.customers.forEach(function (customer) {
                                    customerSelect.append('<option value="' + customer.id + '" data-email="' + (customer.email || '') + '">' + customer.name + '</option>');
                                });

                                // Populate properties (addresses) dropdown
                                var propertySelect = $('select[name="property_id"]');
                                propertySelect.find('option:not(:first)').remove();
                                response.data.addresses.forEach(function (address) {
                                    propertySelect.append('<option value="' + address.id + '">' + (address.full_address || address.address) + '</option>');
                                });

                                // Populate services dropdown
                                var serviceSelect = $('select[name="service_id"]');
                                serviceSelect.find('option:not(:first)').remove();
                                response.data.services.forEach(function (service) {
                                    serviceSelect.append('<option value="' + service.id + '">' + service.name + '</option>');
                                });

                                $('.hmselect2').select2({});

                                // Custom format for customer select
                                customerSelect.select2({
                                    templateResult: function (data) {
                                        if (!data.id) { return data.text; }
                                        var email = $(data.element).attr('data-email');
                                        if (!email) { return data.text; }
                                        return $('<span>' + data.text + '<br><small class="small">' + email + '</small></span>');
                                    }
                                });
                            }
                        });

                    // Submit filter - trigger DataTable refresh
                    $('#submit-scheduled-service-filter').on('click', function (e) {
                        e.preventDefault();
                        scheduledServiceDataTable.ajax.reload();
                    });

                    // Reset filter
                    $('#reset-scheduled-service-filter').on('click', function () {
                        $('#scheduled-service-filter-form')[0].reset();
                        // Show month selection
                        $('#choose-month-container').show();
                        $('#custom-date-range-container').hide();
                        scheduledServiceDataTable.ajax.reload();
                    });

                    // When change the filters
                    $('#scheduled-service-filter-form select, #scheduled-service-filter-form input').on('change', function () {
                        scheduledServiceDataTable.ajax.reload();
                    });

                }

                $('body').on('change', 'select[name="date_range_months"]', function () {
                    if ($(this).val() === 'custom') {
                        $('#custom-date-range-container').show();
                        $('#choose-month-container').hide();
                    } else if ($(this).val() === 'choose_month') {
                        $('#choose-month-container').show();
                        $('#custom-date-range-container').hide();
                    } else {
                        $('#custom-date-range-container').hide();
                        $('#choose-month-container').hide();
                        $('#custom-date-range-container input').val('');
                        // Reset min attribute
                        $('#custom-date-range-container input[name="end_date"]').attr('min', '');
                    }
                });

                // Set end date min attribute based on start date
                $('body').on('change', 'input[name="start_date"]', function () {
                    var startDate = $(this).val();
                    var endDateInput = $('#custom-date-range-container input[name="end_date"]');
                    var endDate = endDateInput.val();

                    if (startDate) {
                        endDateInput.attr('min', startDate);
                        // Clear end date if it's less than start date
                        if (endDate && endDate < startDate) {
                            endDateInput.val('');
                            // Trigger change to reload datatable since value changed
                            endDateInput.trigger('change');
                        }
                    } else {
                        endDateInput.attr('min', '');
                    }
                });
            }
        },
        handleVendorDataTable: function () {
            if ($('#vendors-table').length) {
                var vendorDataTable = $('#vendors-table').DataTable({
                    pageLength: 10,
                    stateSave: false,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    dom: "<'row'<'col-sm-12 col-md-6 d-flex justify-content-start'l i><'col-sm-12 col-md-6'f>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>",
                    ajax: {
                        url: vendor_list_route,
                        type: 'post',
                        data: function (d) {
                            d._token = $('meta[name="csrf-token"]').attr('content');
                        }
                    },
                    columns: [
                        { data: 'name', name: 'name' },
                        { data: 'email', name: 'email' },
                        { data: 'phone_number', name: 'phone_number' },
                        { data: 'orders_count', name: 'orders_count', searchable: false, orderable: false, className: 'text-center' },
                        { data: 'status', name: 'status', class: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, sortable: false, class: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No data available.',
                        search: '',
                        searchPlaceholder: 'Search...',
                        lengthMenu: '_MENU_'
                    },
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    rowCallback: function (row, data, index) {
                        // $(row).find('td:not(:last-child)').on('click', function () {
                        //     window.location.href = "/admin/vendors/" + data.id + "/edit";
                        // });
                    }
                });

                // On init complete add a class
                vendorDataTable.on('init', function () {
                    $('#vendors-table_info').addClass('ps-2 pt-1');
                });

                // Delete user
                $('body').on('click', '.delete-vendor', function (e) {
                    e.preventDefault();
                    let action = $(this).attr('href');

                    var link = $(this);
                    var cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : "Cancel";
                    var confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : "Yes, delete";
                    var title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : "Are you sure?";
                    var text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : "You won't be able to revert this!";

                    Swal.fire({
                        title: title,
                        text: text,
                        input: 'text',
                        inputPlaceholder: 'Type DELETE here',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: cancel,
                        confirmButtonText: confirm,
                        reverseButtons: true,
                        preConfirm: (inputValue) => {
                            if (inputValue !== 'DELETE') {
                                Swal.showValidationMessage('You must type "DELETE" to proceed.');
                                return false;
                            }
                            return true;
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            axios.delete(action)
                                .then(function (response) {
                                    handymanScript.displayToastNotification(response.data.status, handymanScript.capitalize(response.data.status), response.data.message);
                                    vendorDataTable.ajax.reload();
                                })
                                .catch(function (error) {
                                    if (error.response && error.response.data && error.response.data.error) {
                                        handymanScript.displayToastNotification('error', 'Error', error.response.data.error);
                                    } else {
                                        handymanScript.displayToastNotification('error', 'Error', 'An error occurred while deleting the vendor.');
                                    }
                                });
                        }
                    })
                });
            }
        },
        handleVendorTasksDataTable: function () {
            if ($('#vendors-task-table').length) {
                var vendorTasksTable = $('#vendors-task-table').DataTable({
                    pageLength: 10,
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    dom: "<'row'<'col-sm-12 col-md-6 d-flex justify-content-start'l i><'col-sm-12 col-md-6'f>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row'<'col-sm-12 col-md-5'><'col-sm-12 col-md-7'p>>",
                    ajax: {
                        url: vendor_task_list_route,
                        type: 'post'
                    },
                    columns: [
                        { data: 'vendor_name', name: 'handyman.name' },
                        { data: 'property', name: 'order.address.full_address', orderable: false },
                        { data: 'task', name: 'order.order_number' },
                        { data: 'due_date', name: 'order.booking_date' },
                        { data: 'status', name: 'status', className: 'text-center' },
                        { data: 'actions', name: 'actions', searchable: false, orderable: false, className: 'text-center' }
                    ],
                    language: {
                        emptyTable: 'No vendor tasks found.',
                        search: '',
                        searchPlaceholder: 'Search...',
                        lengthMenu: '_MENU_'
                    },
                    order: [[3, "desc"]]
                });

                // On init complete add a class
                vendorTasksTable.on('init', function () {
                    $('#vendors-task-table_info').addClass('ps-2 pt-1');
                });
            }
        },
        init: function () {
            handymanScript.generalElements();
            handymanScript.addDeleteForms();
            handymanScript.bulkCheckUncheck();
            handymanScript.userDataTable();
            handymanScript.handleUserCreate();
            handymanScript.handleCreateUserAdress();
            handymanScript.handleCreateUserRecurringServices();
            handymanScript.handleUserOrderHistory();
            handymanScript.handleAddressOrderHistory();
            handymanScript.smtpDataTable();
            handymanScript.staffDataTable();
            handymanScript.serviceDataTable();
            handymanScript.providerDataTable();
            handymanScript.scheduleDataTable();
            handymanScript.validateChangePasswordForm();
            handymanScript.activityLogDataTable();
            handymanScript.manageAppointments();
            handymanScript.manageQuotations();
            handymanScript.handleWhatsAppMessage();
            handymanScript.handleProjects();
            handymanScript.handleStaticDataTable();
            handymanScript.downloadStaffData();
            handymanScript.propertyDataTable();
            handymanScript.manageQuotationTemplates();
            handymanScript.manageQuickQuotations();
            handymanScript.manageScheduledServices();
            handymanScript.manageScheduledServicesDataTable();
            handymanScript.handleVendorDataTable();
            handymanScript.handleVendorTasksDataTable();
        },
    };
    // Initialize the script
    handymanScript.init();
})();
